import { useEffect, useState, useRef } from "react";
import { useOidc } from "@axa-fr/react-oidc";
import { Modal, Button } from "react-bootstrap"; // Install Bootstrap if needed

const SessionTimeout = () => {
  const { login } = useOidc();
  const timerRef = useRef(null);
  // const [timer, setTimer] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleLogout = () => {
    setShowModal(false);
    login(); // Logout the user
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current); // Clear the existing timer

    timerRef.current = setTimeout(() => {
      setShowModal(true); // Show timeout modal after 45 minutes of inactivity
    }, 30 * 60 * 1000); // 45 minutes
  };

  useEffect(() => {
    resetTimer();
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <>
      {/* Session Timeout Modal */}
      <Modal
        show={showModal}
        onHide={handleLogout}
        centered
        className="sessionModel"
      >
        <Modal.Header>
          <Modal.Title>Session Timeout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your session has expired. Please log in again.</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleLogout}>
            Login
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SessionTimeout;
